"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _isArray = _interopRequireDefault(require("lodash/isArray"));

var _queryString = _interopRequireDefault(require("query-string"));

var _reactRouterDom = require("react-router-dom");

var _UiContext = _interopRequireDefault(require("../context/UiContext"));

var _getObjectDifferences = _interopRequireDefault(require("../utils/getObjectDifferences"));

var _searchParamsToObject = _interopRequireDefault(require("../utils/searchParamsToObject"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useFilter = function useFilter(refForm, defaults, resetParamsAfterFilter) {
  var _ui$_location;

  var _useContext = (0, _react.useContext)(_UiContext.default),
      _useContext2 = _slicedToArray(_useContext, 1),
      ui = _useContext2[0];

  var _useState = (0, _react.useState)({}),
      _useState2 = _slicedToArray(_useState, 2),
      filter = _useState2[0],
      setFilter = _useState2[1];

  var prevURLSearchParams = (0, _react.useRef)({});
  var location = (0, _reactRouterDom.useLocation)();

  var urlParams = _queryString.default.parse(location.search);

  var navigate = (0, _reactRouterDom.useNavigate)();
  (0, _react.useEffect)(function () {
    if (location.search === "") {
      setFilter(_objectSpread({}, defaults));
      return;
    }

    var searchParams = new URLSearchParams(_objectSpread({}, urlParams));
    searchParams.sort();
    var searchParamsObject = (0, _searchParamsToObject.default)(searchParams); // save prev searchParams

    prevURLSearchParams.current = searchParamsObject;
    setFilter(searchParamsObject); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ui === null || ui === void 0 ? void 0 : (_ui$_location = ui._location) === null || _ui$_location === void 0 ? void 0 : _ui$_location.search]);
  (0, _react.useEffect)(function () {
    var _refForm$current;

    if ((refForm === null || refForm === void 0 ? void 0 : (_refForm$current = refForm.current) === null || _refForm$current === void 0 ? void 0 : _refForm$current.getAttribute("data-useFilter")) === null) {
      var _refForm$current2;

      refForm.current.setAttribute("data-useFilter", "");
      refForm === null || refForm === void 0 ? void 0 : (_refForm$current2 = refForm.current) === null || _refForm$current2 === void 0 ? void 0 : _refForm$current2.addEventListener("submit", function (e) {
        e.preventDefault();
        var searchParams = new URLSearchParams(new FormData(refForm === null || refForm === void 0 ? void 0 : refForm.current));
        searchParams.sort();
        var searchParamsObject = (0, _searchParamsToObject.default)(searchParams); // check if resetParamsAfterFilter essential

        if ((0, _isArray.default)(resetParamsAfterFilter) && resetParamsAfterFilter.length > 0) {
          var differences = (0, _getObjectDifferences.default)(searchParamsObject, prevURLSearchParams.current);

          if (differences.length > 0) {
            resetParamsAfterFilter.forEach(function (param) {
              var paramKey = Object.keys(param)[0];
              var paramValue = Object.values(param)[0];

              if (differences.indexOf(paramKey) === -1) {
                searchParamsObject[paramKey] = paramValue;
              }
            });
          } // save prev searchParams


          prevURLSearchParams.current = searchParamsObject;
        } // generate new URLSearchParams
        // to avoid multiple params
        // old: &location=Kitzbühel&location=Oberndorf
        // new: &location=Kitzbühel,Oberndorf


        var newSearchParams = new URLSearchParams();

        for (var key in searchParamsObject) {
          if (searchParamsObject[key]) {
            newSearchParams.append(key, searchParamsObject[key]);
          }
        }

        navigate("?" + newSearchParams);
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [refForm.current]);
  return filter;
};

var _default = useFilter;
exports.default = _default;